import config from './config/system'
import axios from '@/utils/request'
export const tagList = params => axios.post(config.tagList, params)
export const tagTypeFilter = params => axios.post(config.tagTypeFilter, params)
export const tagStatusUpdate = params => axios.post(config.tagStatusUpdate, params)
export const tagListBatchDelete = params => axios.post(config.tagListBatchDelete, params)
export const tagInfoQuery = params => axios.post(config.tagInfoQuery, params)
export const tagSave = params => axios.post(config.tagSave, params)
export const tagUpdate = params => axios.post(config.tagUpdate, params)
export const tagListDelete = params => axios.post(config.tagListDelete, params)

//banner管理
export const bannerList = params => axios.post(config.bannerList, params)
export const bannerPlatformFilter = params => axios.post(config.bannerPlatformFilter, params)
export const bannerListDelete = params => axios.post(config.bannerListDelete, params)
export const bannerStatusUpdate = params => axios.post(config.bannerStatusUpdate, params)
export const bannerAdd = params => axios.post(config.bannerAdd, params)
export const bannerInfo = params => axios.post(config.bannerInfo, params)
export const bannerEdit = params => axios.post(config.bannerEdit, params)

//菜单管理
export const menuList = params => axios.post(config.menuList, params)
export const menuListBatchDelete = params => axios.post(config.menuListBatchDelete, params)
export const menuListCreate = params => axios.post(config.menuListCreate, params)
export const menuListUpdate = params => axios.post(config.menuListUpdate, params)
export const menuQuery = params => axios.post(config.menuQuery, params)
export const systemMenuFilter = params => axios.post(config.systemMenuFilter, params)
export const systemMenuStatusUpdate = params => axios.post(config.systemMenuStatusUpdate, params)
